// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import Vuelidate from 'vuelidate'
import VueAlertify from "vue-alertify"
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import './fonts/HELR65W.woff'
import './fonts/Roboto-Regular.woff'
import VueApexCharts from 'vue-apexcharts'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import VueSimpleAlert from "vue-simple-alert";
import CKEditor from '@ckeditor/ckeditor5-vue';
import i18n from './i18n';
import VueAnalytics from 'vue-analytics';
import Keycloak from 'keycloak-js';
import VueJwtDecode from 'vue-jwt-decode';
import apiUrl from './constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';


Vue.use(VueSidebarMenu);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.use(VueAlertify);
Vue.use(VeeValidate);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VCalendar);
Vue.use(VueSimpleAlert);
Vue.use(CKEditor);
Vue.use(VueAnalytics, {
	id: 'G-FCB2R9Z2RW',
	router
});

let initOptions = {
	url: apiUrl.kavachURL, realm: 'xpressbees', clientId: 'xbwms-ui', onLoad: 'login-required'
}
let keycloak = new Keycloak(initOptions);
let Initialized = localStorage.getItem('keycloakInitialized')
Initialized = Initialized == 'true' ? true : false
if (Initialized) {
	keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
		let trimmedValue = localStorage.getItem('keyclockloginpage')
		trimmedValue = trimmedValue == 'true' ? true : false
		if (!trimmedValue || trimmedValue === '') {
			//keycloak.logout();
			localStorage.setItem("keyclockloginpage", true);
		}
		if (!auth) {
			new Vue({
				i18n,
				el: '#app',
				router,
				template: '<App/>',
				components: {
					App
				}
			});

		} else {
			localStorage.setItem("isLoggedIn", true);
			localStorage.setItem("userToken", keycloak.token);
			localStorage.setItem("refreshToken", keycloak.refreshToken);
			const decoded = VueJwtDecode.decode(keycloak.token);

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getUserPermissionsKavach',
				'data': {tokentype: "web"},
				headers: {
					'Authorization': keycloak.token
				}
			}).then(async(response) => {
				const hasReloaded = localStorage.getItem('hasReloaded'); // added this to prevent infinite reloading
				
				//  response.data = 'Inactive user'
				if (response.data == 'Inactive user') {
					localStorage.removeItem('permissiondata')
					localStorage.removeItem('userdetail')
					localStorage.removeItem('userToken')
					localStorage.removeItem('isLoggedIn')
					localStorage.removeItem('clientList')
					localStorage.removeItem('warehouseList')
					localStorage.removeItem('refreshToken')
					alertify.error("Inactive User")
					if (!hasReloaded) {
						localStorage.setItem('hasReloaded', true);
						window.location.reload();
						router.push('/login');
					} else {
						router.push('/login');
					}


					return false;
				}
				if (response.data == 'Invalid user') {
					alertify.error("Invalid Username Or Password")
					return false;
				}
				if (response.data == 'User Added to WMS') {
					window.location.reload();

				}
				if (response.data == 'Invalid/Unauthorised user' ||  response.data == 'Invalid credentials / Token Expired') {
					localStorage.removeItem('permissiondata')
					localStorage.removeItem('userdetail')
					localStorage.removeItem('userToken')
					localStorage.removeItem('isLoggedIn')
					localStorage.removeItem('clientList')
					localStorage.removeItem('warehouseList')
					localStorage.removeItem('refreshToken')
					router.push('/login');
					return false;
				}


				if (response.data[1].permissions.length > 0) {
					var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[1].permissions), "Key");
					var userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[0].userdetail), "Key");
					window.localStorage.setItem('permissiondata', permissionEncrypt);
					window.localStorage.setItem('userdetail', userdetailEncrypt);
					window.localStorage.setItem('isLoggedIn', true);
					window.localStorage.setItem('userToken', keycloak.token);
					window.localStorage.setItem('refreshToken', keycloak.refreshToken);
					window.localStorage.setItem('locale', response.data[0].userdetail.locale.trim());
					const slaConfigArray = response.data[3].slaconfig;

					const slaConfigJsonString = JSON.stringify(slaConfigArray);

					window.localStorage.setItem('slaconfig', slaConfigJsonString);

					var innerpermissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[2].innerpermission), "Key");
					window.localStorage.setItem('innerpermissiondata', innerpermissionEncrypt);
					if (!hasReloaded) {
						localStorage.setItem('hasReloaded', true);
						window.location.reload();
					} else {
						// Navigate to '/dashboard' using router
						if (window.location.href.indexOf("dashboard") != -1)
							alertify.success("Logged In Successfully")
						router.push('/dashboard');
						
					}


				}
			}).catch((httpException) => {
				localStorage.removeItem('permissiondata')
				localStorage.removeItem('userdetail')
				localStorage.removeItem('userToken')
				localStorage.removeItem('isLoggedIn')
				localStorage.removeItem('clientList')
				localStorage.removeItem('warehouseList')
				localStorage.removeItem('refreshToken')
				alertify.error("Permission failed to load")
				router.push('/login');
				console.error("exception is:::::::::", httpException);
			});
			new Vue({
				i18n,
				el: '#app',
				router,
				template: '<App/>',
				components: {
					App
				}
			});
		}
	})
}

let intializedval = localStorage.getItem('keycloakInitialized')

intializedval = intializedval == 'true' ? true : false
if ((!intializedval || intializedval === '')) {
	localStorage.setItem("keyclockloginpage", false);
	console.log("keycloakInitialized set to true");
	new Vue({
		i18n,
		el: '#app',
		router,
		template: '<App/>',
		components: {
			App
		}
	});


}



// WEBPACK FOOTER //
// ./src/main.js